<template>
  <div class="text-black tab-pane pt-3" id="dtab6" role="tabpanel">
    <h5 class="font-weight-bold">Verlauf</h5>
    <div class="comments ml-2 mt-3">
      <h5 class="border-bottom font-weight-normal font14">Heute</h5>
      <div class="cmmnt mt-2" v-for="row in taskRows">
        <div class="user-com">
          <p>{{ setDate(row.created) }} </p>
          <p class="font-weight-bold">{{row.useraction}}</p>
          <p>{{row.firstname}}  {{row.lastname}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {formatDate} from '../../common'

export default {
  computed: {
    taskRows() {
      return this.$store.state.tasks.taskDetails.pdflawstatusrows
    }
  },
  methods: {
    setDate(date){
      return formatDate(date)
    },
  }
}
</script>
<style scoped>
.cmmnt .user-com p{
  font-size: 0.9rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tasks/preview-tabs/HistoryTab.vue